import '../../../project.scss';
import '../js/src/custom.cms.js'
import '../js/src/project.js'

import '../js/src/basket-list-ele.js';
import '../js/src/ele.accordion.js';
import '../js/src/ele.course.select.js';
import '../js/src/ele.js';
import '../js/src/opacc.class.filter-datepicker.js'
import '../js/src/opacc.filter.js'
import '../js/src/opacc.directsearchsuggest.js'

import '../../../../layout/include/cms/contentbuilder/contentbuilder.css'